import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlHierarchicalResponse extends IIsiDtoPresentationLogicResponse  {
}
export class IsiDtoPlHierarchicalResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlHierarchicalResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Grid.IsiDtoPlHierarchicalResponse, Isilog.IsiComponent.IsiDataTransferObject";

    constructor(data?: IIsiDtoPlHierarchicalResponse) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoPlHierarchicalResponse): IsiDtoPlHierarchicalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlHierarchicalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
export interface IIsiDtoPlHierarchicalRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlHierarchicalResponse;
    actionId?: string;
    gridId?: string;
    mode?: Mode;
}
export enum Mode {
    Classique = 0,
    Hierarchique = 1,
}
export class IsiDtoPlHierarchicalRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlHierarchicalRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Grid.IsiDtoPlHierarchicalRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlHierarchicalResponse;
    actionId?: string;
    gridId?: string;
    mode?: Mode;

    constructor(data?: IIsiDtoPlHierarchicalRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlHierarchicalResponse(data.response) : <IsiDtoPlHierarchicalResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlHierarchicalResponse.fromJS(_data["response"]) : <any>null;
            this.actionId = _data["actionId"] !== undefined ? _data["actionId"] : <any>null;
            this.gridId = _data["gridId"] !== undefined ? _data["gridId"] : <any>null;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : Mode.Classique;
        }
    }

    static fromJS(data?: IIsiDtoPlHierarchicalRequest): IsiDtoPlHierarchicalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlHierarchicalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["actionId"] = this.actionId !== undefined ? this.actionId : <any>null;
        data["gridId"] = this.gridId !== undefined ? this.gridId : <any>null;
        data["mode"] = this.mode !== undefined ? this.mode : Mode.Classique;
        return data;
    }
}
